// Import all services
import {EmbedlyService} from './services/embedly.service';

// Export all services
export * from './services/embedly.service';

// Export convenience property
export const PROVIDERS: any[] = [
  EmbedlyService
];



/** WEBPACK FOOTER **
 ** ./~/tslint-loader?emitErrors=false&failOnHint=false!./src/services.ts
 **/